export default __webpack_public_path__ + "static/ogimage-d3c6c2cb8878098fa474303f7d876231.jpg";